export default __webpack_public_path__ + "static/media/CrossCircleOutlined.9e67ba9b.svg";